export default __webpack_public_path__ + "static/media/ContactImg.15215f1f.png";